export const calcNumOfPages = (count, limit) => Math.ceil(count / limit);
export const calcCurrentPage = (offset, limit) => offset > 0 ? Math.ceil(offset / limit) + 1 : 1;
export const calcIfNextPagePossible = (count, offset, limit) => count > offset + limit;
export const calcIfPreviousPagePossible = (offset) => offset > 0;
const calcIfShouldShrinkLeft = (offset, limit, padding) => {
    const currentPage = calcCurrentPage(offset, limit);
    // 3 === first page button + next page button ('2' or '...') + current page button
    return padding + 3 < currentPage;
};
const calcIfShouldShrinkRight = (count, offset, limit, padding) => {
    const currentPage = calcCurrentPage(offset, limit);
    const numOfPages = calcNumOfPages(count, limit);
    // 2 === last page button + page button preceding the last page button ('...' or a number)
    return currentPage + padding + 2 < numOfPages;
};
const calcIfShouldNotShrink = (count, limit, padding) => {
    const numOfPages = calcNumOfPages(count, limit);
    // the maximum number of page buttons is always even
    // 5 === first, last and current page buttons + '<' + '>'
    // if the padding is '2', there are 2 more page buttons on each side
    // in this case, there are 9 page buttons
    return numOfPages <= padding * 2 + 5;
};
const genRange = (start, end) => Array(end - start + 1)
    .fill(start)
    .map((el, i) => String(el + i));
export const genPaginationLabels = (count, offset, limit, padding) => {
    const currentPage = calcCurrentPage(offset, limit);
    const numOfPages = calcNumOfPages(count, limit);
    const shouldNotShrink = calcIfShouldNotShrink(count, limit, padding);
    const shouldShrinkLeft = calcIfShouldShrinkLeft(offset, limit, padding);
    const shouldShrinkRight = calcIfShouldShrinkRight(count, offset, limit, padding);
    if (shouldNotShrink) {
        return genRange(1, numOfPages);
    }
    else if (!shouldShrinkLeft && shouldShrinkRight) {
        return [...genRange(1, padding * 2 + 3), '…', String(numOfPages)];
    }
    else if (shouldShrinkLeft && !shouldShrinkRight) {
        return ['1', '…', ...genRange(numOfPages - padding * 2 - 2, numOfPages)];
    }
    else {
        return [
            '1',
            '…',
            ...genRange(currentPage - padding, currentPage + padding),
            '…',
            String(numOfPages)
        ];
    }
};
//# sourceMappingURL=utils.js.map